import ApiService from "../../ApiService";

const DefaultService = {
    loadScreenView: (successCallback, failureCallback) => {
        ApiService.post("/mobile/studyletter/default/loadscreenview", {}, successCallback, failureCallback);
    },
    loadTaskList: (courseId, successCallback, failureCallback) => {
        ApiService.post("/mobile/studyletter/default/loadtasklist", {courseId}, successCallback, failureCallback);
    },
    loadTaskDetails: (letters, successCallback, failureCallback) => {
        ApiService.post("/mobile/studyletter/default/loadtaskdetails", {letters}, successCallback, failureCallback);
    },
    loadLetterDetails: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/studyletter/default/loadletterdetails", vo, successCallback, failureCallback);
    },
    loadWordDetails: (id, successCallback, failureCallback) => {
        ApiService.post("/mobile/studyletter/default/loadworddetails", {id}, successCallback, failureCallback);
    },
    loadLetterStates: (successCallback, failureCallback) => {
        ApiService.post("/mobile/studyletter/default/loadletterstates", {}, successCallback, failureCallback);
    },
    updateViewed: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/studyletter/default/updateviewed", vo, successCallback, failureCallback);
    },
    loadLetterByState: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/studyletter/default/loadlettersbystate", vo, successCallback, failureCallback);
    },
    loadTopList: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/studyletter/default/loadtoplist", vo, successCallback, failureCallback);
    },
    updateNotSee: (vo, successCallback, failureCallback) => {
        ApiService.post("/mobile/studyletter/default/updatenotsee", vo, successCallback, failureCallback);
    },
};

export default DefaultService;
